import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-cookie-banner-modal',
  templateUrl: './cookie-banner-modal.component.html',
  styleUrls: ['./cookie-banner-modal.component.scss'],
  standalone: false,
})
export class CookieBannerModalComponent implements AfterViewInit {
  @ViewChild('acceptButton') acceptButton: ElementRef;

  constructor(public activeModal: NgbActiveModal) {}

  get hostname(): string {
    return window.location.hostname;
  }

  ngAfterViewInit(): void {
    this.acceptButton.nativeElement.focus();
  }

  afterViewInit;

  reject() {
    this.activeModal.close(false);
  }

  accept() {
    this.activeModal.close(true);
  }
}
